
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.4 21.1l.2-11.8M7.4 9.3l.2 13.9-5 3.8V5h26.8v22M2.6 9.3h26.8M7.6 23.1H14"}}),_c('path',{attrs:{"d":"M29.3 27H14v-5.9h15.3V27"}})])
          )
        }
      }
    